/*
  Project: Partnership LA
  Author: Xfive
 */

import fix100vh from './fixes/100vh';
import objectFit from './polyfills/object-fit';
import closest from './polyfills/closest';
import lazyLoad from './modules/lazy-load';
import header from './modules/header';
import homeSlides from './modules/home-slides';
import readMore from './modules/read-more';
import slides from './modules/slides';
import accordions from './modules/accordions';
import seeAll from './modules/tiles-more';
import overlay from './modules/overlay';
import share from './modules/share';

fix100vh();
objectFit();
closest();
lazyLoad();
header();
homeSlides();
readMore();
slides();
accordions();
seeAll();
overlay();
share();



// WEBPACK FOOTER //
// ./src/scripts/app.js